<template>
  <div>
    <div :class="{ 'select-picture-dialog': type === 'mainSelect' }">
      <el-dialog
        width="880px"
        title="图片管理"
        :visible.sync="selectPicDialog"
        @close="closeDialog"
        destroy-on-close
        custom-class="sorting-code-number"
        :lock-scroll="type !== 'mainSelect'"
        :modal="type !== 'mainSelect'"
        :modal-append-to-body="type !== 'mainSelect'"
      >
        <div class="el-dialog__body-bodys">
          <div class="bodys-left">
            <treeList
              ref="treeList"
              :defaultProps="defaultProps"
              @updateImgList="updateImgList"
              :reNodeName="reNodeName"
            ></treeList>
          </div>
          <div class="bodys-right">
            <div class="bodys-right-searchLine">
              <el-search :formProp="form" @search="search">
                <template slot="search">
                  <el-input
                    style="display: block"
                    v-model.trim="form.imgName"
                    clearable
                    placeholder="请输入图片名称模糊查询"
                  ></el-input>
                </template>
              </el-search>
              <el-button @click="uploadPic" plain class="uploadBtn"
                >上传图片</el-button
              >
            </div>
            <el-checkbox-group
              v-model="checkList"
              :class="{ 'hidden-number-check': type === 'mainSelect' }"
            >
              <el-checkbox
                :label="item.uploadId"
                @change="imgAllListAdd(item)"
                :key="index"
                :checked="item.checked"
                v-for="(item, index) in imgList"
              >
                <div
                  class="bodys-right-images"
                  @click="imgAllListAdd(item)"
                  @mouseenter="clickPop(item)"
                  @mouseleave="closePop"
                  :ref="`bt` + item.uploadId"
                >
                  <div class="bodys-right-image-box" @click="sendImg(item)">
                    <img class="bodys-right-image" :src="item.url" alt="" />
                    <div class="bodys-right-image-size">{{ item.size }}</div>
                    <div class="bodys-right-image-name">{{ item.name }}</div>
                    <div
                      class="bodys-right-select-image-index"
                      v-show="checkList.includes(item.uploadId)"
                    >
                      {{ checkList.indexOf(item.uploadId) + 1 }}
                    </div>
                  </div>
                </div>
              </el-checkbox>
            </el-checkbox-group>

            <el-popover
              v-if="showPop"
              ref="pop"
              :reference="reference"
              placement="top"
              trigger="hover"
            >
              <img
                :src="hoverImg"
                alt=""
                style="max-width: 800px; max-height: 800px"
                @mouseenter="$refs.pop.doShow()"
                @mouseleave="$refs.pop.doClose()"
              />
            </el-popover>

            <div id="ccui-paging" v-if="total > 1">
              <el-pagination
                :total="totalNum"
                :page-size="pageSizeCode"
                :current-page="pageNoCode"
                :page-sizes="[20, 50, 80, 100]"
                prev-text="< 上一页"
                next-text="下一页 >"
                background
                layout="sizes, prev, pager, next, jumper"
                popper-class="ccui-paging-page-size-popper"
                @prev-click="handlePrev"
                @next-click="handleNext"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
              <el-button
                class="ccui-pagination-btn"
                size="mini"
                type="default"
                @click="handleSizeChange('none')"
                >确定</el-button
              >
            </div>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <!-- <span @click="managerPicture" class="footer-managerPicture"
            >进入图片管理</span
          > -->
          <el-button
            size="mini"
            type="default-mini"
            @click="selectPicDialog = false"
            >取 消</el-button
          >
          <el-button
            size="mini"
            type="primary-font-mini"
            @click="sendImgs"
            v-if="type !== 'mainSelect'"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <upLoadPicture
      ref="UpLoadPicture"
      type="UpLoadPicture"
      @getFileId="getFileId"
      @refresh="refresh"
    />
  </div>
</template>

<script>
import treeList from "./treeList";
import upLoadPicture from "./upLoadPicture";
import { qryImage, qryImageFile, addImageFile } from "./pictureManage";

export default {
  name: "selectPicture",
  props: {
    // 上传图片信息列表
    fileList: {
      type: Array,
      default() {
        return [];
      }
    },
    // 使用该组件的位置 mainSelect主图 PCSelect Pc信息 meditorSelect手机信息
    type: {
      type: String,
      default() {
        return "mainSelect";
      }
    },
    // PC信息中的富文本
    editorText: {
      type: String,
      default() {
        return "";
      }
    },
    // 存储在localstorage中的key
    reNodeName: {
      type: String,
      default() {
        return "";
      }
    }
  },
  components: { treeList, upLoadPicture },
  data() {
    return {
      // 懒加载树的配置
      defaultProps: {
        label: "fileName", // label 名称字段
        isLeaf: "leaf" // 是否展示末级
      },
      selectPicDialog: false, // 是否展示弹窗
      checkList: [], // 选中的图片uploadId列表
      imgAllList: [], // 所有选择过的图片
      copyEditorText: "", // 拷贝的富文本
      imgList: [], // 存储当前页面图片的列表
      form: {
        // 搜索条件
        imgName: ""
      },
      pageNoCode: 1, //当前页数
      pageSizeCode: 50, //默认每页显示条目个数
      totalNum: 1, //总条目数
      total: 1,
      searchData: {},
      reference: {},
      // 控制渲染条件 如果不用v-if会报错 具体可自行尝试
      showPop: false,
      // 保存当前激活的refrence id
      activeId: "", // 鼠标悬浮的图片
      hoverImg: "", // 打开大图
      timer: "", // 演示显示
      shopId: ""
    };
  },
  mounted() {},
  methods: {
    // 鼠标移出时关闭大图
    closePop() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.$refs.pop.doClose();
      }
    },
    // 鼠标移入时，展示大图
    clickPop(item) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.$refs.pop.doClose();
      }
      // 这个操作是为了避免与源码中的点击reference doToggle方法冲突
      // if (this.activeId === item.uploadId && this.showPop) return
      this.showPop = false;
      this.activeId = item.uploadId;
      // 因为reference是需要获取dom的引用 所以需要是$el
      this.reference = this.$refs["bt" + item.uploadId][0];
      this.$nextTick(() => {
        // 等待显示的popover销毁后再 重新渲染新的popover
        this.showPop = true;
        this.$nextTick(() => {
          // 此时才能获取refs引用
          this.timer = setTimeout(() => {
            this.$refs.pop.doShow();
            console.log("show");
          }, 1500);
          this.hoverImg = item.url.split("?")[0];
        });
      });
    },

    //当前页数改变
    handleCurrentChange(val) {
      this.pageNoCode = val;
      console.log("fileId", this.fileId);
      this.updateImgList(this.searchData);
    },
    //当前页条数改变
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      if (val !== "none") {
        this.pageNoCode = 1;
        this.pageSizeCode = val;
        this.updateImgList(this.searchData);
      }
    },
    //上一页
    handlePrev() {
      --this.pageNoCode;
      console.log("上一页");
      this.updateImgList(this.searchData);
    },
    // 下一页
    handleNext() {
      ++this.pageNoCode;
      console.log("下一页");
      this.updateImgList(this.searchData);
    },

    // 打开或者关闭弹窗
    open(e) {
      localStorage.removeItem("uploadpicture");
      this.shopId = localStorage.getItem("shopId");
      if (this.type === "mainSelect") {
        console.log("mainSelect");
        if (
          e &&
          e.target &&
          e.target.className === "el-upload el-upload--picture-card"
        ) {
          this.selectPicDialog = !this.selectPicDialog;
        }
        return;
      }

      this.checkList = [];
      this.imgAllList = [];
      this.selectPicDialog = !this.selectPicDialog;
    },
    // 关闭弹窗
    closeDialog() {
      this.checkList = [];
      this.imgAllList = [];
      this.selectPicDialog = false;
      console.log("关闭");
    },
    // 搜索图片
    search(searchData) {
      console.log("searchData", searchData);
      this.updateImgList(searchData);
    },
    // 主图选择时调用，选择图片
    sendImg(img) {
      if (this.type === "mainSelect") {
        if (this.fileList && this.fileList.length >= 8) {
          this.$message({
            showClose: true,
            ccuiCustom: true,
            type: "error",
            message: "最多只允许上传8张图片",
            duration: 8000
          });
          return;
        }
        img.url = img.url.split("?")[0];
        this.fileList.push(img);
        this.$emit("uploadPic", this.fileList);
      }
    },
    // PC富文本 手机端Json 传出信息
    sendImgs() {
      console.log("this.imgAllList", this.imgAllList);
      console.log("this.checkList", this.checkList);
      let imgAllData = this.imgAllList;
      if (this.type === "PCSelect") {
        let picJson = "";
        this.checkList.map(res => {
          imgAllData.map(item => {
            if (item.uploadId === res) {
              let url = item.url.split("?")[0];
              let uploadId = item.response.data[0].uploadId;
              picJson +=
                '<img src="' + url + '" alt="' + uploadId + '" />' + "<br/>";
            }
          });
        });
        let editorText = JSON.parse(JSON.stringify(this.editorText));
        editorText += picJson;
        this.$emit("update:editorText", editorText);
      } else if (this.type === "meditorSelect") {
        this.checkList.map(res => {
          imgAllData.map(item => {
            if (item.uploadId === res) {
              let url = item.url.split("?")[0];
              let uploadId = item.uploadId;
              let data = { data: [url, uploadId] };
              this.$emit("insertMeditorPicturer", data);
            }
          });
        });
      }
      this.open();
    },
    // 所勾选过的图片保存到列表中
    imgAllListAdd(item) {
      console.log(item, "item......");
      let exists = false;
      for (let i = 0; i < this.imgAllList.length; i++) {
        if (this.imgAllList[i].uploadId === item.uploadId) {
          exists = true;
          break;
        }
      }
      if (exists) {
        return;
      }

      this.imgAllList.push(item);
      console.log("添加图片入库", this.imgAllList);
    },
    // 打开上传图片弹框,判断是否有上传图片的文件夹
    uploadPic() {
      console.log("打开上传图片弹窗");
      let req = {
        parentId: 0,
        shopId: localStorage.getItem("shopId")
      };
      qryImageFile(req).then(res => {
        console.log(res, "res");
        if (res.data.data && res.data.data.length > 0) {
          this.$refs.UpLoadPicture.open();
        } else {
          this.addPictureFiles();
          // this.$message({
          //   showClose: true,
          //   message: "图片文件夹还未创建，请先前往【图片管理】模块创建文件夹！",
          //   type: "error",
          //   ccuiCustom: true,
          //   duration: 8000,
          // });
        }
      });
    },
    addPictureFiles() {
      addImageFile({
        fileName: "默认",
        parentId: 0,
        shopId: localStorage.getItem("shopId")
      }).then(() => {
        this.uploadPic();
      });
    },
    // 上传完毕后，刷新页面
    refresh() {
      this.getFileId(this.fileId);
    },
    // 获取当前页面信息
    getFileId(id) {
      this.updateImgList({ fileId: id });
    },
    // 跳转到 管理图片页面
    managerPicture() {
      // 判断是否拥有图片管理应用权限
      let menu = this.$store.state.app.menu;
      let pictureManageUnopen = true;
      menu.map(res => {
        if (res.keyword === "pictureManage") {
          pictureManageUnopen = false;
        }
      });

      if (pictureManageUnopen) {
        this.$router.push("/305");
        // this.$message({
        //   showClose: true,
        //   message: "该账户暂无【图片管理】应用权限，请联系应用管理员为您开启该权限",
        //   type: "error",
        //   ccuiCustom: true,
        //   duration:8000
        // });

        return;
      }

      let routeData = this.$router.resolve({
        path: "/pictureManage/pictureManage-list",
        query: {
          a: this.$route.query.a
        }
      });
      window.open(routeData.href, "_blank");
    },
    // 获取页面图片数据
    updateImgList(data) {
      this.fileId = data.imgName || data.fileId;
      this.searchData = data;
      // data.isPage=0
      data.pageNo = this.pageNoCode;
      data.pageSize = this.pageSizeCode;
      data.shopId = localStorage.getItem("shopId");

      qryImage(data).then(res => {
        let imgList = res.data.data.rows;
        let tempList = [];
        imgList.forEach(res => {
          let obj = {};
          obj.url =
            res.imgAddress.split("?")[0] +
            "?x-image-process=image/resize,m_lfit,h_100,w_100";
          obj.size = res.imgSize;
          obj.name = res.imgName;
          obj.percentage = 100;
          obj.uploadId = res.uploadId;
          obj.response = {
            data: [
              {
                downloadUrl: res.imgAddress,
                uploadId: res.uploadId
              }
            ]
          };
          tempList.push(obj);
        });
        this.imgList = tempList;

        this.totalNum = res.data.data.recordsTotal;
        this.total = res.data.data.total;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.hidden-number-check {
  /deep/.el-checkbox__input {
    display: none;
  }
  .bodys-right-select-image-index {
    display: none;
  }
}
/deep/.el-checkbox__input {
  position: absolute;
  top: 3px;
  left: 2px;
}
/deep/.el-form-item.upload-list {
  padding-right: 0;
}
/deep/.el-checkbox {
  margin-right: 0;
}
/deep/.el-checkbox__label {
  padding-left: 0px;
}

.select-picture-dialog /deep/.el-dialog__wrapper {
  position: absolute !important;
  top: inherit;
  left: -4px;
  right: inherit;
  bottom: -600px;
  overflow: inherit;
  margin: 0;
  transform: translateX(0px);
}

/deep/.el-search .el-searchs-left {
  display: none;
}
.bodys-right {
  width: 73% !important;
  .bodys-right-searchLine {
    display: inline-block;
    width: 100%;

    .uploadBtn {
      display: inline-block;
      color: #ff142f;
      border: solid #ff142f 1px;
      font-weight: 600;
      font-size: 14px;
      float: right;
      &:hover {
        background-color: rgba(234, 188, 188, 0.29);
      }
    }

    /deep/.el-search {
      float: left;
    }
    /deep/.el-search .el-searchs-box {
      width: 250px !important;
    }
  }
  .bodys-right-images {
    display: flex;
    flex-wrap: wrap;
    .bodys-right-image-box {
      position: relative;
      margin-right: 20px;
      &:nth-child(5n) {
        margin-right: 0;
      }
      .bodys-right-image {
        width: 100px;
        height: 100px;
        display: inline-block;
      }
      .bodys-right-image-size {
        position: absolute;
        left: 0;
        top: 80px;
        width: 100px;
        text-align: center;
        background: #000000;
        opacity: 0.4;
        color: #fff;
        height: 20px;
        line-height: 18px;
        font-size: 13px;
        margin-left: 0px;

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .bodys-right-image-name {
        margin-top: 10px;
        margin-bottom: 20px;
        font-size: 14px;
        width: 100px;
        text-align: center;
        height: 16px;
        line-height: 16px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .bodys-right-select-image-index {
        position: absolute;
        right: 0;
        top: 5px;
        width: 18px;
        height: 16px;
        border-radius: 18px 0px 0px 18px;
        text-align: center;
        background: #000000;
        opacity: 0.4;
        color: #fff;
        line-height: 16px;
        font-size: 13px;
        margin-left: 0px;
      }
    }
  }
}
.bodys-left {
  position: fixed;
  width: 200px !important;
  height: 450px !important;
  /deep/.el-tree {
    padding: inherit !important;
    width: auto !important;
    margin-top: 10px;
    margin-left: 5px;
    .is-leaf.el-icon-caret-right:before {
      content: none;
    }
  }
}
/deep/.sorting-code-number .el-dialog__body {
  width: 840px;
}
/deep/.sorting-code-number .el-dialog__body .el-dialog__body-bodys {
  height: 99%;
}
.footer-managerPicture {
  font-size: 13px;
  float: left;
  color: #0089ef;
  cursor: pointer;
}
</style>
